import React, { useEffect, useState } from 'react';
import {
    EuiBasicTable,
    EuiFlexItem,
    EuiButton,
    EuiBadge,
    EuiSpacer,
    htmlIdGenerator,
    EuiText,
    EuiIcon,
    EuiTextColor,
    EuiLoadingContent,
    EuiCard,
    EuiFlexGroup,
} from '@elastic/eui';
import { useSelector, useDispatch } from 'react-redux';
import * as types from '../../reduxStore/types/orders';
import RupeeSymbol from '../rupeeComponent.js/index.js';
import { ReactComponent as PickUp } from '../../assets/img/pickUp.svg';
import { ReactComponent as Moped } from '../../assets/img/moped.svg';
import { ReactComponent as DineIn } from '../../assets/img/dineIn.svg';
import { isEmpty } from 'lodash';
import { getPastOrders } from '../../api/pastOrder/getPastOrders';
import { getAbandonedOrders } from '../../api/abandonedOrders/getAbandonedOrders';
import { getCustomerOrders } from '../../api/customer/getCustomerOrders';
import TimerComponent from './timerComponent';
import { getFailedOrders } from '../../api/failedOrders/getFailedOrder';
import { ReactComponent as TableIcon } from '../../assets/img/svg/LiveOrderTableIcon.svg';
import TableHeader from './TableHeader';
import { outletIdArray } from '../reports/Reports';
import { ALL_OUTLET } from '../../reduxStore/types/outlet';

export const refundMessage = (refund) => {
    const refunds = [];

    refund.forEach((item) => {
        if (item.refunded_at) {
            refunds.push(
                <>
                    <EuiSpacer size='xs' />
                    <EuiFlexItem style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <EuiIcon size='s' type='checkInCircleFilled' color='success' />
                        &nbsp;
                        <EuiText size='xs'>
                            <EuiTextColor color='secondary'>Refund Succeed</EuiTextColor>
                        </EuiText>
                    </EuiFlexItem>
                </>
            );
        }

        if (item.initiated_at && !item.failed_at && !item.refunded_at) {
            refunds.push(
                <>
                    <EuiSpacer size='xs' />
                    <EuiFlexItem style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <EuiIcon size='s' type='checkInCircleFilled' color='warning' />
                        &nbsp;
                        <EuiText size='xs'>
                            <EuiTextColor color='warning'>Refund Inititated</EuiTextColor>
                        </EuiText>
                    </EuiFlexItem>
                </>
            );
        }

        if (item.failed_at) {
            refunds.push(
                <>
                    <EuiSpacer size='xs' />
                    <EuiFlexItem style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <EuiIcon size='s' type='checkInCircleFilled' color='danger' />
                        &nbsp;
                        <EuiText size='xs'>
                            <EuiTextColor color='danger'>Refund Failed</EuiTextColor>
                        </EuiText>
                    </EuiFlexItem>
                </>
            );
        }
    });

    return refunds;
};

const LiveOrdersTableForPast = (props) => {
    const [items, setItems] = useState([]);
    let orders = useSelector((state) =>
        props.isPast
            ? state.orders.pastOrders
            : props.isCustomerOrder
              ? state.customer.customerOrderDetails
              : props.isAbandoned
                ? state.orders.abandonedCarts
                : props.isFailedOrders
                  ? state.orders.failedOrders
                  : state.orders.liveOrders
    );
    const currentOrderState = useSelector((state) => state.orders.currentOrderState);
    const currentOrderingMode = useSelector((state) => state.orders.currentOrderingMode);
    const tableLoader = useSelector((state) => state.orders.tableLoader);
    const ordersCount = useSelector((state) => state.orders.ordersCount);
    const selectedOrderId = useSelector((state) => state.orders.selectedOrderId);
    const selectedOutletId = useSelector((state) => state.outlet.selectedOutletId);
    const themeMode = useSelector((state) => state.theme.theme);
    const dispatch = useDispatch();
    const [newOrders, setNewOrders] = useState([]);

    const [pagination, setPagination] = useState({
        pageIndex: 0,
        totalItemCount: 0,
        pageSize: 10,
        pageSizeOptions: [10, 50, 100],
    });

    useEffect(() => {
        if (props.isPast || props.isAbandoned || props.isCustomerOrder || props.isFailedOrders) {
            setPagination({
                pageIndex: props.state.current_page,
                totalItemCount: props.state.totalCounts,
                pageSize: props.state.page_size,
                pageSizeOptions: [10, 50, 100],
            });
            dispatch({
                type: types.SET_ORDER_CURRENT_PAGE,
                payload: { current_page: props.state.current_page, page_size: props.state.page_size },
            });
        }
    }, [props.state]);

    const pastOrders = useSelector((state) => state.orders.pastOrders);
    const filteredOrder = pastOrders.filter((data) => data.order_id === selectedOrderId);
    const failedOrders = useSelector((state) => state.orders.failedOrders);
    const filteredFailedOrder = failedOrders.filter((data) => data.order_id === selectedOrderId);
    const abandonedCarts = useSelector((state) => state.orders.abandonedCarts);
    const filteredAbandonedOrder = abandonedCarts.filter((data) => data.cart_id === selectedOrderId);
    const selectedOutlet = useSelector((state) => state.outlet.selectedOutlet);
    const outletList = useSelector((state) => state.outlet.outletList);

    useEffect(() => {
        if (filteredOrder.length < 1 && pastOrders.length > 0 && props.isPast) {
            dispatch({
                type: types.SET_SELECTED_ORDER,
                payload: pastOrders[0].order_id,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filteredOrder, props.isPast]);

    useEffect(() => {
        if (filteredFailedOrder.length < 1 && failedOrders.length > 0 && props.isFailedOrders) {
            dispatch({
                type: types.SET_SELECTED_ORDER,
                payload: failedOrders[0].order_id,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filteredFailedOrder]);

    useEffect(() => {
        if (filteredAbandonedOrder.length < 1 && abandonedCarts.length > 0) {
            dispatch({
                type: types.SET_SELECTED_ORDER,
                payload: abandonedCarts[0].cart_id,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filteredAbandonedOrder]);

    const apiPaginationCall = (state, orderingMode) => {
        if (props.isPast && selectedOutletId) {
            let outletString = '';
            if (selectedOutlet) {
                if (selectedOutlet.value === ALL_OUTLET) {
                    outletString = outletIdArray(outletList);
                } else {
                    outletString = outletIdArray([selectedOutlet]);
                }
            }

            dispatch({
                type: 'set-table-loader',
                payload: { loader: true, error: false },
            });
            dispatch(getPastOrders(props.startDateTime, props.endDateTime, state, orderingMode, outletString)).then(
                (res) => {
                    dispatch({
                        type: 'set-table-loader',
                        payload: { loader: false, error: false },
                    });
                    setPagination({
                        ...pagination,
                        pageIndex: res.order_collection.orders.current_page - 1,
                        totalItemCount: res.order_collection.orders.total,
                    });
                }
            );
        } else if (props.isAbandoned) {
            dispatch({
                type: 'set-table-loader',
                payload: { loader: true, error: false },
            });
            dispatch(getAbandonedOrders(props.startDateTime, props.endDateTime, state, orderingMode)).then((res) => {
                dispatch({
                    type: 'set-table-loader',
                    payload: { loader: false, error: false },
                });
                setPagination({
                    ...pagination,
                    pageIndex: res.carts.data.current_page - 1,
                    totalItemCount: res.carts.data.total,
                });
            });
        } else if (props.isCustomerOrder) {
            dispatch({
                type: 'set-table-loader',
                payload: { loader: true, error: false },
            });
            dispatch(getCustomerOrders(props.startDateTime, props.endDateTime, state, orderingMode)).then((res) => {
                dispatch({
                    type: 'set-table-loader',
                    payload: { loader: false, error: false },
                });
                setPagination({
                    ...pagination,
                    pageIndex: res.order_collection.orders.current_page - 1,
                    totalItemCount: res.order_collection.orders.total,
                });
            });
        } else if (props.isFailedOrders) {
            dispatch({
                type: 'set-table-loader',
                payload: { loader: true, error: false },
            });
            dispatch(getFailedOrders(props.startDateTime, props.endDateTime, state, orderingMode)).then((res) => {
                dispatch({
                    type: 'set-table-loader',
                    payload: { loader: false, error: false },
                });
                setPagination({
                    ...pagination,
                    pageIndex: res.order_collection.orders.current_page - 1,
                    totalItemCount: res.order_collection.orders.total,
                });
            });
        }
    };

    useEffect(() => {
        apiPaginationCall(props.state, currentOrderingMode);
    }, [props.state, props.endDateTime, props.startDateTime, selectedOutletId]);

    const onTableChange = ({ page = {} }) => {
        const { index: pageIndex, size: pageSize } = page;
        setPagination({ ...pagination, pageIndex, pageSize });
        props.setState({
            ...props.state,
            current_page: pageIndex,
            page_size: pageSize,
        });
    };

    const [state, setState] = useState(true);

    const setTimeOutFunction = (liveOrder) => {
        if (liveOrder?.ordering_mode === 'takeaway' && liveOrder?.status?.restaurant_ready_at) {
            let date1 = new Date(liveOrder?.status?.restaurant_ready_at);
            let date2 = new Date();
            let differenceInMs = date2.getTime() - date1.getTime();

            if (differenceInMs / 60000 < 5) {
                const timer = setTimeout(() => {
                    setState(htmlIdGenerator()());
                }, differenceInMs);
            }
        }
    };

    const riderStatus = (order) => {
        if (order?.status?.rider_accept_at) {
            if (order.status.rider_picked_up_at) {
                return 'Rider picked up';
            } else if (order.status.rider_reached_to_location_at) {
                return 'Rider reached location';
            } else if (order.status.rider_reached_restaurant_at) {
                return 'Rider reached restaurant';
            } else if (order.status.rider_accept_at) {
                return 'Rider accepted';
            }
        }

        return false;
    };

    useEffect(() => {
        let allOrders = [];
        let newOrders = [];
        orders.map((liveOrder) => {
            if (
                !liveOrder?.status?.restaurant_accepted_at &&
                currentOrderState === 'all' &&
                window.location.pathname === '/live-orders'
            ) {
                newOrders.push({
                    id: !props.isAbandoned ? liveOrder.order_id : liveOrder.cart_id,
                    customer: liveOrder?.customer?.name,
                    // age: props.isAbandoned ? getTimeAgo(liveOrder.updated_at) : getTimeAgo(liveOrder.status.placed_at),
                    age: props.isAbandoned ? liveOrder.updated_at : liveOrder.status.placed_at,
                    value: liveOrder.net_total,
                    type: liveOrder.ordering_mode,
                    status: liveOrder?.status?.delivery_status ? liveOrder?.status?.delivery_status : '',
                    order_details: liveOrder,
                    setTimeOut: setTimeOutFunction(liveOrder),
                });
            } else {
                allOrders.push({
                    id: !props.isAbandoned ? liveOrder.order_id : liveOrder.cart_id,
                    customer: liveOrder?.customer?.name,
                    // age: props.isAbandoned ? getTimeAgo(liveOrder.updated_at) : getTimeAgo(liveOrder.status.placed_at) ,
                    age: props.isAbandoned ? liveOrder.updated_at : liveOrder.status.placed_at,
                    value: liveOrder.net_total,
                    type: liveOrder.ordering_mode,
                    status: liveOrder?.status?.delivery_status ? liveOrder?.status?.delivery_status : '',
                    order_details: liveOrder,
                    setTimeOut: setTimeOutFunction(liveOrder),
                });
            }
        });
        setNewOrders(newOrders);
        setItems(allOrders);
        // getNewOrders()
    }, [orders, state]);

    // useEffect(() => {
    //     if(!isEmpty(orders) && window.location.pathname === '/live-orders'){
    //         let newOrdersData = []
    //         newOrdersData = orders.filter((data) => !data?.status?.restaurant_accepted_at);
    //         orders = orders.filter((data) => data?.status?.restaurant_accepted_at);
    //         setNewOrders(newOrdersData)
    //     }
    // }, [orders])

    const orderStatus = (item) => {
        if (item.order_details?.status?.rider_picked_up_at) {
            return 'DISPATCHED';
        }

        if (item.order_details?.status?.restaurant_ready_at) {
            return 'READY';
        }
        if (item.order_details?.status?.restaurant_accepted_at) {
            return 'PREPARING';
        }

        return 'PENDING';
    };

    const calculateElapsedTime = (selectedOrder) => {
        if (selectedOrder?.status?.restaurant_ready_at) {
            let date1 = new Date(selectedOrder?.status?.restaurant_ready_at);
            let date2 = new Date();
            let differenceInMins = (date2.getTime() - date1.getTime()) / 60000;

            return differenceInMins > 5;
        }
        return false;
    };

    const paymentMethod = (payment) => {
        if (!isEmpty(payment)) {
            switch (payment.payment_method) {
                case 'CREDIT_CARD':
                    return 'CREDIT CARD';
                case 'DEBIT_CARD':
                    return 'DEBIT CARD';
                case 'NET_BANKING':
                    return 'NET BANKING';
                case 'BALANCE':
                    return 'PAYTM';
                case 'UPI':
                    return 'UPI';
                case 'UPI_INTENT':
                    return 'UPI';
                case 'CREDIT_CARD/DEBIT_CARD':
                    return 'STRIPE';
                case 'CASH_ON_DELIVERY':
                    return 'CASH';
                case 'CCAVENUE':
                    return 'ONLINE';
            }
        }

        return 'PENDING';
    };

    let columnsData = [
        {
            field: 'customer',
            name: 'Customer',
            sortable: true,
            width: '40%',
            'data-test-subj': 'firstNameCell',
            render: (customer, item) => {
                const type = item?.order_details?.ordering_mode_details?.type
                    ? item?.order_details?.ordering_mode_details?.type
                    : item?.type?.ordering_mode_details?.type
                      ? item?.type?.ordering_mode_details?.type
                      : item?.type?.ordering_mode;

                if (props.isPast || props.isCustomerOrder || props.isFailedOrders) {
                    return (
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <EuiFlexItem>
                                <EuiText size='s'>{customer}</EuiText>
                                <EuiFlexGroup gutterSize='s' alignItems='center' justifyContent='flexStart'>
                                    {type ? (
                                        <EuiFlexItem grow={false}>
                                            {type === 'qsr' || type === 'fine_dine' ? (
                                                <TableIcon
                                                    height='18'
                                                    width='18'
                                                    fill={themeMode === 'light' ? 'black' : 'white'}
                                                />
                                            ) : null}
                                        </EuiFlexItem>
                                    ) : null}
                                    <EuiFlexItem grow={false}>
                                        <EuiText size='xs'>
                                            <EuiTextColor color='warning'>
                                                {type === 'self_serve'
                                                    ? 'Self Serve'
                                                    : item?.order_details?.table?.internal_name}
                                            </EuiTextColor>
                                        </EuiText>
                                    </EuiFlexItem>
                                </EuiFlexGroup>
                            </EuiFlexItem>
                            {item.order_details?.status?.order_failed_at ? (
                                <>
                                    <EuiSpacer size='xs' />
                                    <EuiFlexItem style={{ flexDirection: 'row', alignItems: 'center' }}>
                                        <EuiIcon size='s' type='crossInACircleFilled' color='danger' />
                                        &nbsp;
                                        <EuiText size='xs'>
                                            <EuiTextColor color='danger'>Failed Order</EuiTextColor>
                                        </EuiText>
                                    </EuiFlexItem>
                                </>
                            ) : item.order_details?.status?.customer_picked_up_at !== null ||
                              item.order_details?.status?.rider_delivered_at !== null ||
                              item.order_details?.status?.delivered_at ? (
                                <>
                                    <EuiSpacer size='xs' />
                                    <EuiFlexItem style={{ flexDirection: 'row', alignItems: 'center' }}>
                                        <EuiIcon size='s' type='checkInCircleFilled' color='success' />
                                        &nbsp;
                                        <EuiText size='xs'>
                                            <EuiTextColor color='secondary'>Delivered Order</EuiTextColor>
                                        </EuiText>
                                    </EuiFlexItem>
                                </>
                            ) : (
                                <>
                                    <EuiSpacer size='xs' />
                                    <EuiFlexItem style={{ flexDirection: 'row', alignItems: 'center' }}>
                                        <EuiIcon size='s' type='crossInACircleFilled' color='danger' />
                                        &nbsp;
                                        <EuiText size='xs'>
                                            <EuiTextColor color='danger'>Cancelled Order</EuiTextColor>
                                        </EuiText>
                                    </EuiFlexItem>
                                </>
                            )}

                            {item?.order_details && item?.order_details?.refunds?.length
                                ? refundMessage(item.order_details.refunds)
                                : ''}
                        </div>
                    );
                } else if (
                    item.order_details.rider ||
                    item.order_details.elt_order ||
                    item.order_details.dunzo_order ||
                    item.order_details.wefast_order ||
                    item.order_details.scout_order ||
                    item.order_details.shadowfax_order
                ) {
                    return (
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <EuiText size='s'>{customer}</EuiText>
                            {!props.isPast && !props.isAbandoned && !props.isCustomerOrder ? (
                                <>
                                    <EuiSpacer size='xs' />
                                    <EuiFlexItem style={{ flexDirection: 'row', alignItems: 'center' }}>
                                        {item.order_details?.status?.rider_accept_at ? (
                                            <>
                                                <Moped fill='#017D73' height='16' width='16' />
                                                &nbsp;
                                                <EuiText size='xs'>
                                                    <EuiTextColor color='secondary'>
                                                        {riderStatus(item.order_details)}
                                                    </EuiTextColor>
                                                </EuiText>
                                            </>
                                        ) : (
                                            <>
                                                <EuiIcon size='s' type='checkInCircleFilled' color='success' />
                                                &nbsp;
                                                <EuiText size='xs'>
                                                    <EuiTextColor color='secondary'>Rider Assigned</EuiTextColor>
                                                </EuiText>
                                            </>
                                        )}
                                    </EuiFlexItem>
                                </>
                            ) : (
                                ''
                            )}
                        </div>
                    );
                } else if (item.order_details.rider_assignment_action_required) {
                    return (
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <EuiText size='s'>{customer}</EuiText>
                            {!props.isPast && !props.isAbandoned && !props.isCustomerOrder ? (
                                <>
                                    <EuiSpacer size='xs' />
                                    <EuiFlexItem style={{ flexDirection: 'row', alignItems: 'center' }}>
                                        <EuiIcon size='s' type='alert' color='danger' />
                                        &nbsp;
                                        <EuiText size='xs'>
                                            <EuiTextColor color='danger' size='xs'>
                                                Action required
                                            </EuiTextColor>{' '}
                                        </EuiText>
                                    </EuiFlexItem>
                                </>
                            ) : (
                                ''
                            )}
                        </div>
                    );
                } else if (
                    item.order_details.ordering_mode === 'delivery' &&
                    !(
                        item.order_details.rider ||
                        item.order_details.elt_order ||
                        item.order_details.dunzo_order ||
                        item.order_details.wefast_order ||
                        item.order_details.scout_order ||
                        item.order_details.shadowfax_order
                    )
                ) {
                    return (
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <EuiText size='s'>{customer}</EuiText>
                            {!props.isPast && !props.isAbandoned && !props.isCustomerOrder ? (
                                <>
                                    <EuiSpacer size='xs' />
                                    <EuiFlexItem style={{ flexDirection: 'row', alignItems: 'center' }}>
                                        <EuiIcon size='s' type='iInCircle' color='warning' />
                                        &nbsp;
                                        <EuiText size='xs'>
                                            <EuiTextColor color='warning' size='xs'>
                                                Rider not assigned
                                            </EuiTextColor>{' '}
                                        </EuiText>
                                    </EuiFlexItem>
                                </>
                            ) : (
                                ''
                            )}
                        </div>
                    );
                } else if (
                    calculateElapsedTime(item.order_details) &&
                    item.order_details.ordering_mode !== 'delivery'
                ) {
                    return (
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <EuiText size='s'>{customer}</EuiText>
                            {!props.isPast && !props.isAbandoned && !props.isCustomerOrder ? (
                                <>
                                    <EuiSpacer size='xs' />

                                    <EuiFlexItem style={{ flexDirection: 'row', alignItems: 'center' }}>
                                        <EuiIcon size='s' type='alert' color='danger' />
                                        &nbsp;
                                        <EuiText size='xs'>
                                            <EuiTextColor color='danger' size='xs'>
                                                Action required
                                            </EuiTextColor>{' '}
                                        </EuiText>
                                    </EuiFlexItem>
                                </>
                            ) : (
                                ''
                            )}
                        </div>
                    );
                }

                return (
                    <EuiFlexItem>
                        <EuiText size='s'>{customer}</EuiText>
                        <EuiFlexGroup gutterSize='none' alignItems='center' justifyContent='flexStart'>
                            <EuiFlexItem grow={false}>
                                {type === 'qsr' || type === 'fine_dine' ? (
                                    <TableIcon
                                        height='18'
                                        width='18'
                                        fill={themeMode === 'light' ? 'black' : 'white'}
                                    />
                                ) : null}
                            </EuiFlexItem>
                            <EuiFlexItem grow={false} style={{ marginLeft: '6px' }}>
                                <EuiText size='xs'>
                                    <EuiTextColor color='warning'>
                                        {type === 'self_serve'
                                            ? 'Self Serve'
                                            : item?.order_details?.table?.internal_name}
                                    </EuiTextColor>
                                </EuiText>
                            </EuiFlexItem>
                        </EuiFlexGroup>
                    </EuiFlexItem>
                );
            },
        },
        {
            field: 'age',
            name: 'Age',
            width: '15%',
            truncateText: true,
            align: 'center',
            render: (age) => {
                return <TimerComponent time={age} />;
                // let diffMS = calculateElapsedTimeMS(item.order_details)
                // return (
                //     <Timer initialTime={diffMS ? diffMS : 0} lastUnit="m">
                //         <Timer.Minutes /> Mins
                //     </Timer>
                // )
            },
        },
        {
            field: 'value',
            name: 'Value',
            width: '15%',
            align: 'center',
            render: (value, item) => {
                return (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div>
                            <EuiText size='s'>
                                <RupeeSymbol size={'14px'} />
                                {value}
                            </EuiText>
                        </div>
                        {!props.isAbandoned ? (
                            <>
                                <EuiSpacer size='xs' />
                                <div
                                    style={{
                                        border:
                                            item?.order_details?.payment_method?.payment_method == 'CASH_ON_DELIVERY'
                                                ? '1px solid rgb(246, 131, 15)'
                                                : '1px solid rgb(14, 145, 140)',
                                    }}
                                >
                                    <EuiText style={{ margin: '0 2px' }} size='xs'>
                                        {paymentMethod(item?.order_details?.payment_method)}
                                    </EuiText>
                                </div>
                            </>
                        ) : (
                            ''
                        )}
                    </div>
                );
            },
        },
        {
            field: 'type',
            name: 'Type',
            width: '15%',
            align: 'center',
            render: (type) => {
                if (type === 'takeaway') {
                    return (
                        <EuiFlexItem style={{ alignItems: 'center' }}>
                            <PickUp height='18' width='18' fill={themeMode === 'light' ? 'black' : 'white'} />{' '}
                            <span style={{ fontSize: '12px' }}>Takeaway</span>{' '}
                        </EuiFlexItem>
                    );
                } else if (type === 'delivery') {
                    return (
                        <EuiFlexItem style={{ alignItems: 'center' }}>
                            <Moped height='18' width='18' fill={themeMode === 'light' ? 'black' : 'white'} />{' '}
                            <span style={{ fontSize: '12px' }}>Delivery</span>{' '}
                        </EuiFlexItem>
                    );
                } else if (type === 'dine_in') {
                    return (
                        <EuiFlexItem style={{ alignItems: 'center' }}>
                            <DineIn height='18' width='18' fill={themeMode === 'light' ? 'black' : 'white'} />{' '}
                            <span style={{ fontSize: '12px' }}>Dine in</span>{' '}
                        </EuiFlexItem>
                    );
                }
            },
        },
        {
            field: 'status',
            name: 'Status',
            width: '15%',
            align: 'center',
            render: (status, item) => {
                let statusData = orderStatus(item);
                return (
                    <EuiBadge
                        color={
                            statusData === 'PENDING'
                                ? '#275AF6'
                                : statusData === 'PREPARING'
                                  ? '#4DBE9F'
                                  : statusData === 'READY'
                                    ? '#1B1A28'
                                    : '#C0C5FF'
                        }
                    >
                        {statusData}
                    </EuiBadge>
                );
            },
        },
    ];

    const [columns, setColumns] = useState([]);
    useEffect(() => {
        if (props.isPast || props.isAbandoned || props.isCustomerOrder || props.isFailedOrders) {
            let innerColumns = [...columnsData];
            innerColumns.splice(4, 1);
            setColumns(innerColumns);
        } else {
            setColumns(columnsData);
        }
    }, []);

    const getRowProps = (item) => {
        const { id } = item;
        return {
            'data-test-subj': `row-${id}`,
            style: { backgroundColor: selectedOrderId == id ? (themeMode === 'light' ? '#f5f7fa' : '#6d737e') : '' },
            className: 'customRowClass',
            onClick: () => {
                dispatch({
                    type: types.SET_SELECTED_ORDER,
                    payload: id,
                });
            },
        };
    };

    const getCellProps = (item, column) => {
        const { id } = item;
        const { field } = column;
        return {
            className: 'customCellClass',
            'data-test-subj': `cell-${id}-${field}`,
            textOnly: true,
        };
    };

    const onChangeRadio = (name) => {
        dispatch({
            type: types.SET_CURRENT_ORDER_MODE,
            payload: name,
        });

        apiPaginationCall({ current_page: 0, page_size: 10 }, name);
    };

    const onStatusChange = (type) => {
        dispatch({
            type: types.SET_CURRENT_ORDER_STATE,
            payload: type,
        });
    };

    return (
        <>
            <EuiFlexItem grow={1}>
                <TableHeader
                    isFailedOrders={props.isFailedOrders}
                    isCustomerOrder={props.isCustomerOrder}
                    isPast={props.isPast}
                    isAbandoned={props.isAbandoned}
                    onChangeRadio={onChangeRadio}
                />
            </EuiFlexItem>

            {!props.isPast && !props.isAbandoned && !props.isCustomerOrder && !props.isFailedOrders ? (
                <>
                    <EuiSpacer />
                    <EuiFlexItem
                        grow={1}
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            width: '100%',
                            height: '32px',
                            backgroundColor: 'rgba(105, 112, 125, 0.2)',
                        }}
                    >
                        <EuiFlexItem
                            style={{
                                backgroundColor: currentOrderState === 'all' ? '#0071c2' : 'rgba(105, 112, 125, 0.2)',
                                justifyContent: 'center',
                                width: '20%',
                                boxShadow: currentOrderState === 'all' ? '0 0 7px 0 rgba(0, 0, 0, 0.5)' : '',
                                borderRadius: currentOrderState === 'all' ? '3px' : '',
                            }}
                        >
                            <EuiButton
                                onClick={() => onStatusChange('all')}
                                style={{
                                    fontSize: '14px',
                                    textDecorationLine: 'none',
                                    border: 'none',
                                    boxShadow: 'none',
                                    background: 'transparent',
                                    color: currentOrderState === 'all' ? '#FFFFFF' : '#5a606b',
                                }}
                            >
                                All ({ordersCount.all})
                            </EuiButton>
                        </EuiFlexItem>

                        <EuiFlexItem
                            style={{
                                backgroundColor:
                                    currentOrderState === 'placed' ? '#0071c2' : 'rgba(105, 112, 125, 0.2)',
                                justifyContent: 'center',
                                width: '20%',
                                boxShadow: currentOrderState === 'placed' ? '0 0 7px 0 rgba(0, 0, 0, 0.5)' : '',
                                borderRadius: currentOrderState === 'placed' ? '3px' : '',
                            }}
                        >
                            <EuiButton
                                onClick={() => onStatusChange('placed')}
                                style={{
                                    fontSize: '14px',
                                    textDecorationLine: 'none',
                                    border: 'none',
                                    boxShadow: 'none',
                                    background: 'transparent',
                                    color: currentOrderState === 'placed' ? '#FFFFFF' : '#5a606b',
                                }}
                            >
                                Pending ({ordersCount.placed ? ordersCount.placed : 0})
                            </EuiButton>
                        </EuiFlexItem>

                        <EuiFlexItem
                            style={{
                                backgroundColor:
                                    currentOrderState === 'restaurant_accepted'
                                        ? '#0071c2'
                                        : 'rgba(105, 112, 125, 0.2)',
                                justifyContent: 'center',
                                width: '20%',
                                boxShadow:
                                    currentOrderState === 'restaurant_accepted' ? '0 0 7px 0 rgba(0, 0, 0, 0.5)' : '',
                                borderRadius: currentOrderState === 'restaurant_accepted' ? '3px' : '',
                            }}
                        >
                            <EuiButton
                                onClick={() => onStatusChange('restaurant_accepted')}
                                style={{
                                    fontSize: '14px',
                                    textDecorationLine: 'none',
                                    border: 'none',
                                    boxShadow: 'none',
                                    background: 'transparent',
                                    color: currentOrderState === 'restaurant_accepted' ? '#FFFFFF' : '#5a606b',
                                }}
                            >
                                Preparing ({ordersCount.restaurant_accepted ? ordersCount.restaurant_accepted : 0})
                            </EuiButton>
                        </EuiFlexItem>

                        <EuiFlexItem
                            style={{
                                backgroundColor:
                                    currentOrderState === 'restaurant_ready' ? '#0071c2' : 'rgba(105, 112, 125, 0.2)',
                                justifyContent: 'center',
                                width: '20%',
                                boxShadow:
                                    currentOrderState === 'restaurant_ready' ? '0 0 7px 0 rgba(0, 0, 0, 0.5)' : '',
                                borderRadius: currentOrderState === 'restaurant_ready' ? '3px' : '',
                            }}
                        >
                            <EuiButton
                                onClick={() => onStatusChange('restaurant_ready')}
                                style={{
                                    fontSize: '14px',
                                    textDecorationLine: 'none',
                                    border: 'none',
                                    boxShadow: 'none',
                                    background: 'transparent',
                                    color: currentOrderState === 'restaurant_ready' ? '#FFFFFF' : '#5a606b',
                                }}
                            >
                                Ready ({ordersCount.restaurant_ready ? ordersCount.restaurant_ready : 0})
                            </EuiButton>
                        </EuiFlexItem>

                        <EuiFlexItem
                            style={{
                                backgroundColor:
                                    currentOrderState === 'rider_picked_up' ? '#0071c2' : 'rgba(105, 112, 125, 0.2)',
                                justifyContent: 'center',
                                width: '20%',
                                boxShadow:
                                    currentOrderState === 'rider_picked_up' ? '0 0 7px 0 rgba(0, 0, 0, 0.5)' : '',
                                borderRadius: currentOrderState === 'rider_picked_up' ? '3px' : '',
                            }}
                        >
                            <EuiButton
                                onClick={() => onStatusChange('rider_picked_up')}
                                style={{
                                    fontSize: '14px',
                                    textDecorationLine: 'none',
                                    border: 'none',
                                    boxShadow: 'none',
                                    background: 'transparent',
                                    color: currentOrderState === 'rider_picked_up' ? '#FFFFFF' : '#5a606b',
                                }}
                            >
                                Dispatched ({ordersCount.rider_picked_up ? ordersCount.rider_picked_up : 0})
                            </EuiButton>
                        </EuiFlexItem>
                    </EuiFlexItem>
                </>
            ) : null}

            <EuiFlexItem style={{ marginTop: '10px' }} grow={8}>
                {!tableLoader.loader ? (
                    <>
                        {newOrders.length ? (
                            <EuiFlexItem>
                                <EuiCard
                                    style={{
                                        backgroundColor: themeMode === 'light' ? '#dfe7ff' : '#445a91',
                                        padding: '0px',
                                        boxShadow:
                                            '0 10px 10px -2px rgb(152 162 179 / 30%), 0 1px 24px -2px rgb(152 162 179 / 30%)',
                                    }}
                                    paddingSize='none'
                                    layout='horizontal'
                                    title={
                                        <EuiFlexItem style={{ padding: '5px 10px' }}>
                                            <EuiText size='s'>
                                                <h3>
                                                    <b>New Orders</b>
                                                </h3>
                                            </EuiText>
                                        </EuiFlexItem>
                                    }
                                    description={
                                        <EuiBasicTable
                                            items={newOrders}
                                            rowHeader='firstName'
                                            columns={columns}
                                            rowProps={getRowProps}
                                            cellProps={getCellProps}
                                            noItemsMessage='No orders found'
                                            pagination={
                                                props.isPast ||
                                                props.isAbandoned ||
                                                props.isCustomerOrder ||
                                                props.isFailedOrders
                                                    ? pagination
                                                    : ''
                                            }
                                            onChange={
                                                props.isPast ||
                                                props.isAbandoned ||
                                                props.isCustomerOrder ||
                                                props.isFailedOrders
                                                    ? onTableChange
                                                    : ''
                                            }
                                        />
                                    }
                                />
                                <EuiSpacer size='m' />
                            </EuiFlexItem>
                        ) : null}
                        <EuiFlexItem>
                            {newOrders.length ? (
                                <EuiText size='s'>
                                    <h3>
                                        <b>Running orders</b>
                                    </h3>
                                </EuiText>
                            ) : null}
                            <EuiBasicTable
                                items={items}
                                rowHeader='firstName'
                                columns={columns}
                                rowProps={getRowProps}
                                cellProps={getCellProps}
                                noItemsMessage='No orders found'
                                pagination={
                                    props.isPast || props.isAbandoned || props.isCustomerOrder || props.isFailedOrders
                                        ? pagination
                                        : ''
                                }
                                onChange={
                                    props.isPast || props.isAbandoned || props.isCustomerOrder || props.isFailedOrders
                                        ? onTableChange
                                        : undefined
                                }
                            />
                        </EuiFlexItem>
                    </>
                ) : (
                    <EuiLoadingContent lines={10} />
                )}
            </EuiFlexItem>
        </>
    );
};

export default LiveOrdersTableForPast;
